var _defs, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _path, _circle78, _circle79, _circle80, _circle81;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcess01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 800",
    width: 1200,
    height: 800,
    role: "img",
    "aria-label": "Abstract illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gprocess01",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2F6560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163936"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wprocess01",
    cx: 0.2,
    cy: 0.1,
    r: 0.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#83ADA9",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83ADA9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "oprocess01",
    cx: 0.85,
    cy: 0.85,
    r: 0.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF4804",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4804",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "#F5F8F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#wprocess01)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#oprocess01)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 210,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 272,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 334,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 396,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 458,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 520,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 582,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 210,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 272,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 334,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 396,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 458,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 520,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 582,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 210,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 272,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 334,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 396,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 458,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 520,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 582,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 486,
    cy: 210,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 486,
    cy: 272,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 486,
    cy: 334,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 486,
    cy: 396,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 486,
    cy: 458,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 486,
    cy: 520,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 486,
    cy: 582,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 548,
    cy: 210,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 548,
    cy: 272,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 548,
    cy: 334,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 548,
    cy: 396,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 548,
    cy: 458,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 548,
    cy: 520,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 548,
    cy: 582,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 210,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 272,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 334,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 396,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 458,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 520,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 582,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 672,
    cy: 210,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 672,
    cy: 272,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 672,
    cy: 334,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 672,
    cy: 396,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 672,
    cy: 458,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 672,
    cy: 520,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 672,
    cy: 582,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 734,
    cy: 210,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 734,
    cy: 272,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 734,
    cy: 334,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 734,
    cy: 396,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 734,
    cy: 458,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 734,
    cy: 520,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 734,
    cy: 582,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 796,
    cy: 210,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 796,
    cy: 272,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 796,
    cy: 334,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 796,
    cy: 396,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 796,
    cy: 458,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 796,
    cy: 520,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 796,
    cy: 582,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 858,
    cy: 210,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 858,
    cy: 272,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 858,
    cy: 334,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 858,
    cy: 396,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 858,
    cy: 458,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 858,
    cy: 520,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 858,
    cy: 582,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 920,
    cy: 210,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 920,
    cy: 272,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 920,
    cy: 334,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 920,
    cy: 396,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 920,
    cy: 458,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 920,
    cy: 520,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 920,
    cy: 582,
    r: 3.5,
    fill: "#548A85",
    fillOpacity: 0.32
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 400,
    r: 150,
    fill: "#F5F8F7",
    fillOpacity: 0.1
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 400,
    r: 150,
    fill: "none",
    stroke: "#FF4804",
    strokeOpacity: 0.8,
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 666 506 L 770 610",
    stroke: "#FF4804",
    strokeOpacity: 0.8,
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 430,
    r: 7,
    fill: "#2F6560",
    fillOpacity: 0.9
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 542,
    cy: 366,
    r: 11,
    fill: "#2F6560",
    fillOpacity: 0.9
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 584,
    cy: 430,
    r: 7,
    fill: "#2F6560",
    fillOpacity: 0.9
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 626,
    cy: 366,
    r: 11,
    fill: "#2F6560",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess01);
export default __webpack_public_path__ + "static/media/process-01.06a9be0a35f145b4357f191962315848.svg";
export { ForwardRef as ReactComponent };